"use client";

import Heading from "~/componentsDS/Typography/Heading";
import Reveal from "~/componentsDS/Reveal";
import Paragraph from "~/componentsDS/Typography/Paragraph";
import { GTM_EVENT_NAMES } from "~/constants/gtmEvents";
import ElementorContainer from "~/componentsDS/ElementorLoyout/ElementorContainer";
import OestraIcon from "@/icons/products/product-oestra-colored-label-with-r.svg";
import { cn } from "~/lib/utils";
import BlackBox from "~/componentsDS/BlackBox";
import AnimatedCounter from "~/componentsDS/AnimatedCounter";

const stats = [
    { value: 98, text: "improved \nvaginal dryness", startValue: 49 },
    { value: 81, text: "improved \nsleep quality" , startValue: 41},
    { value: 80, text: "improved mood", startValue: 40 },
    { value: 85, text: "sharper focus \nand vitality" ,startValue: 43},
    { value: 80, text: "improved energy levels" ,startValue: 40},
];

const eventData = {
    event: "user_interaction",
    value: {
        event_name: GTM_EVENT_NAMES.LP_INTERACTION,
        widget: "lp_fda_announcement",
        meta_data: {
            click_text: "More info"
        },
    },
};

type EliminateSymptomsSectionProps = {
    showBlackBox?: boolean;
    sectionClassName?: string;
};

const EliminateSymptomsSection = ({
    showBlackBox = true,
    sectionClassName,
}: EliminateSymptomsSectionProps) => {
    return (
        <section className={cn("py-16 md:py-24 font-suisseBP text-primary500", sectionClassName)}>
            <ElementorContainer innerClassName="flex flex-col">
                <Reveal>
                    {showBlackBox && (
                        <BlackBox className="order-1 md:hidden mb-16 bg-primary100 md:bg-transparent text-primary500 p-4 rounded-2xl" eventData={eventData} />
                    )}
                    <div className="mb-4 lg:mb-6">
                        <OestraIcon />
                    </div>
                    <Heading as="h2" size="sm" sizes={{ md: "md" }} className="text-primary500">
                        Eliminate symptoms in just{" "}
                        <span className="italic text-[28px] md:text-[36px] font-featureDisplay font-normal">a few weeks</span>
                    </Heading>
                </Reveal>

                <Paragraph className="text-[18px] leading-[1.3]">
                    In a 8-week outcome review of women using Oestra<sup>®</sup>:
                </Paragraph>

                <div className="grid grid-cols-2 gap-2 lg:grid-cols-5">
                    {stats.map(({ value, text ,startValue}, index) => {
                        return (
                            <h3
                                key={text}
                                className={cn(
                                    "flex h-[169px] lg:h-[148px] w-full flex-col items-center justify-center rounded-[8px]",
                                    "bg-[linear-gradient(180deg,rgba(25,34,61,0.89)_2.38%,#2A3966_39.78%,#A9B9E5_161.17%)]",
                                    "text-center text-pureWhite",
                                    index === stats.length - 1 && "col-span-2 max-w-none lg:col-span-1 h-[100px] lg:h-[148px]"
                                )}
                            >
                                <div className="flex items-start justify-center ml-5 md:ml-0">
                                    <Heading as="span" className="font-featureDisplay text-[36px] md:text-[51px] leading-[1.2] tracking-[0.36px] md:tracking-[-0.03em]">
                                        <AnimatedCounter from={startValue} to={value} />%
                                    </Heading>
                                    {" "}
                                </div>

                                <Paragraph as="span" className="mt-1 whitespace-pre-line md:whitespace-normal text-[18px] font-normal leading-[1.18] tracking-[-0.02em]">
                                    {text}
                                </Paragraph>
                            </h3>
                        )
                    })}
                </div>

                <Paragraph className="text-[18px] leading-[1.3] text-primary500 font-medium">
                    These changes reflect restored hormone levels — not temporary symptom masking.
                </Paragraph>

            </ElementorContainer>
        </section>
    );
}

export default EliminateSymptomsSection
